import React from 'react'
import { cn } from '@/common/utils/utils'
import { Label } from './Label'

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    title: string
    description?: string
    checked?: boolean
    badgeText?: string
    className?: string
    onChange: () => void
}

export const LabelInputRadio = React.forwardRef<HTMLInputElement, Props>(
    ({ className, required, id, title, description, checked, onChange, disabled, badgeText, ...props }, ref) => {
        const handleLabelClick = (event: React.MouseEvent<HTMLLabelElement>) => {
            if (disabled) return

            const target = event.target as HTMLElement
            if (target.tagName !== 'INPUT' && !checked) {
                onChange()
            }
        }

        return (
            <Label
                htmlFor={id}
                onClick={handleLabelClick}
                className={cn(
                    `flex flex-col items-start p-4 gap-2 max-w-[520px] min-h-[100px]
                rounded-lg flex-none order-0 self-stretch transition border
                ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
                ${checked ? 'bg-[#ECEFE9] border-black' : 'bg-white border-[#D5D8D3]'}
                `,
                    className,
                )}
            >
                <div className="flex flex-row items-center gap-4">
                    <span className="flex flex-row items-start gap-2 w-4 h-4 relative">
                        <input
                            ref={ref}
                            id={id}
                            required={required}
                            type="radio"
                            checked={checked}
                            disabled={disabled}
                            onChange={() => {
                                if (!disabled) {
                                    onChange()
                                }
                            }}
                            className="appearance-none w-4 h-4 rounded-full border border-[#D5D8D3] bg-white checked:border-[#223A32] checked:bg-white
                            focus:outline-none focus:border-[#16a34a] focus:ring-1 focus:ring-[#16a34a] transition"
                            {...props}
                        />
                        {/* Custom radio indicator */}
                        <span
                            className={cn(
                                'pointer-events-none absolute left-0 top-0 w-4 h-4 rounded-full border border-[#D5D8D3] bg-white',
                            )}
                        />
                        {checked && (
                            <span className="pointer-events-none absolute left-1 top-1 w-2 h-2 rounded-full bg-[#223A32]" />
                        )}
                    </span>
                    <span className="font-medium text-[14px] leading-[20px] text-black">{title}</span>
                    {badgeText && (
                        <span className="inline-flex items-center rounded-full border border-[#D5D8D3] px-2 py-0.5 text-xs font-medium text-[#223A32]">
                            {badgeText}
                        </span>
                    )}
                </div>
                {description && (
                    <div className="flex flex-col items-start pl-8 gap-2">
                        <span className="font-normal text-[14px] leading-[20px] text-[#737671]">{description}</span>
                    </div>
                )}
            </Label>
        )
    },
)
